///////////////////////////////// Services ///////////////////////////////

export const services = [
    {
        title: 'App Devlopment',
        icon1: 'Android',
        img1: 'imgs/icons/android.svg',
        icon2: 'iPhone',
        img2: 'imgs/icons/apple.svg',
        icon3: 'Cross Platform',
        img3: 'imgs/icons/tablet.svg',
        text: 'Explore All the App Development Opportunities.',
    },
    {
        title: "Web Development",
        icon1: 'ui/ux',
        img1: 'imgs/icons/ux.svg',
        icon2: 'php',
        img2: 'imgs/icons/php.svg',
        icon3: 'java',
        img3: 'imgs/icons/java.svg',
        icon4: 'wordpress',
        img4: 'imgs/icons/wordpress.svg',
        text: 'Explore All the Web Development Opportunities.',
    },
    {
        title: 'Graphic Design',
        icon1: 'logo',
        img1: 'imgs/icons/photoshop.svg',
        icon2: 'brochures',
        img2: 'imgs/icons/illustrator.svg',
        icon3: 'Creatives',
        img3: 'imgs/icons/indesign.svg',
        text: 'Explore All the Graphic Designing Opportunities.'
    },
    {
        title: 'Digital marketing',
        icon1: 'seo',
        img1: 'imgs/icons/facebook.svg',
        icon2: 'smo',
        img2: 'imgs/icons/instagram.svg',
        icon3: 'smm',
        img3: 'imgs/icons/youtube.svg',
        img4: 'imgs/icons/google-ads.svg',
        text: 'Explore All the Digital Marketing Opportunities.'
    },

]

/////////////////////////// Portfolio ///////////////////////////////

export const navPortfolio = [
    {
        itemInfo: 'Health Korner',
        category: 'website',
        img: 'imgs/work/web1.png'
    },

    {
        itemInfo: 'Consilio Research Lab OÜ',
        category: 'website',
        img: 'imgs/work/web2.png'
    },
    {
        itemInfo: 'Dr Puja Jain',
        category: 'website',
        img: 'imgs/work/web3.png'
    },
    {
        itemInfo: 'GISR Foundation ',
        category: 'website',
        img: 'imgs/work/web4.png'
    },
    {
        itemInfo: 'IIWA Awards 2021 ',
        category: 'website',
        img: 'imgs/work/web5.png'
    },
    {
        itemInfo: 'ICACDS 2021 ',
        category: 'website',
        img: 'imgs/work/web6.png'
    },
    {
        itemInfo: 'Saffronified ',
        category: 'website',
        img: 'imgs/work/web7.png'
    },
    {
        itemInfo: 'Tartech LLP ',
        category: 'website',
        img: 'imgs/work/web8.png'
    },
    {
        itemInfo: 'Affiliate Indians ',
        category: 'website',
        img: 'imgs/work/web9.png'
    },
    {
        itemInfo: 'Daily Needs & Sweets ',
        category: 'app',
        img: 'imgs/work/app1.png'
    },
    {
        itemInfo: 'My Easy Doctor ',
        category: 'app',
        img: 'imgs/work/app2.png'
    },
    {
        itemInfo: 'The Career Factory ',
        category: 'app',
        img: 'imgs/work/app3.png'
    },
    {
        itemInfo: 'GISR Foundation ',
        category: 'app',
        img: 'imgs/work/app4.png'
    },
    {
        itemInfo: 'Edugross ',
        category: 'app',
        img: 'imgs/work/app5.png'
    },
    {
        itemInfo: 'Agrajan Sevak ',
        category: 'app',
        img: 'imgs/work/app5.png'
    },
]

///////////////////////////// Badges /////////////////////////////

export const badges = [
    {
        img: "imgs/awards/1.png",
    },
    {
        img: "imgs/awards/2.png",
    },
    {
        img: "imgs/awards/3.png",
    },
    {
        img: "imgs/awards/4.png",
    },

]

///////////////////////// whychoose ///////////////////////////////

export const whychoose = [
    {
        name: 'Creating Quintessential',
        content: 'Creating your perfect for your business',
        image: 'imgs/icons/research.svg'
    },
    {
        name: 'Ingenious Solutions',
        content: 'Uniqueness of your business shown to everyone else in the world',
        image: 'imgs/icons/chat.svg'
    },
    {
        name: 'Transparency with Clients',
        content: 'Everything that we do gets approved first.',
        image: 'imgs/icons/monitor.svg'
    },
    {
        name: 'Research & Analysis',
        content: 'Complete research of what you and your business want from us',
        image: 'imgs/icons/trasparency.svg'
    },

]

//////////////////////////////// stats /////////////////////////

export const stats = [

    {
        counter: '200k+',
        img: 'imgs/icons/deal.svg',
        content: 'Hours Worked'
    },
    {
        counter: '24/7',
        img: 'imgs/icons/computers.svg',
        content: 'Support Available'
    },
    {
        counter: '100+',
        img: 'imgs/icons/worker.svg',
        content: 'Happy Clients'
    },
    {
        counter: '150+',
        img: 'imgs/icons/customer-service.svg',
        content: 'Projects Done'
    },
]

////////////////////////////////////// service 2////////////////////////////

export const service2 = [
    {
        text: 'iOS App Development',
        img: 'imgs/service/mob-service-item2.png'
    },
    {
        text: 'Android App Development',
        img: 'imgs/service/mob-service-item1.png'
    },
    {
        text: 'Cross Platform App Development',
        img: 'imgs/service/mob-service-item3.png'
    },
    {
        text: 'Wearable App Development',
        img: 'imgs/service/mob-service-item4.png'
    },
]

///////////////////////////////// service 4 ///////////////////////////////

export const service4 = [
    {
        title: 'Reliable Services',
        img: 'imgs/icons/teama.svg'
    },
    {
        title: 'Complete Transparency',
        img: 'imgs/icons/link.svg'
    },
    {
        title: 'Quality Assured',
        img: 'imgs/icons/tech.svg'
    },
    {
        title: 'On-time delivery',
        img: 'imgs/icons/hi.svg'
    },
    {
        title: '24/7 support',
        img: 'imgs/icons/badge.svg'
    },
    {
        title: 'Effective Communication',
        img: 'imgs/icons/tin.svg'
    },
]

//////////////////////////////// Projects ////////////////////////////////////

export const projects = [
    {
        itemInfo: 'Daily Needs & Sweets ',
        img: 'imgs/work/app1.png'
    },
    {
        itemInfo: 'My Easy Doctor ',
        img: 'imgs/work/app2.png'
    },
    {
        itemInfo: 'The Career Factory ',
        img: 'imgs/work/app3.png'
    },
]

//////////////////////////////// Reviews //////////////////////////////////////

export const reviews = [
    {
        reviewText: "We were unknown to each other when I became their client now after a couple of months. We are a family that's how friendly & convenient this company is.",
        clientName: 'Ayush Sharma',
        clientDetails: 'Founder, Weddingrows',
    },
    {
        reviewText: 'I met them for one of my project. I must tell you people here are so enthusiastic that they provide you end to end solutions in every case.  I am really pleased by their team efforts and definitely refer S K Info Techies. All the best ✌️',
        clientName: 'Pankaj Mishra ',
        clientDetails: 'Founder, P N D Global Logistics'
    },
    {
        reviewText: 'SK Info Techies is best in providing quality solutions in web development and graphic designing. I am glad to be associated with SK Info Techies.',
        clientName: 'AK Chaudhary',
        clientDetails: 'Director, GISR Foundation'
    }
]


///////////////////////////////// whychoose2 ////////////////////////////////

export const whychoose2 = [
    {
        title: 'Reliable Services',
        img: 'imgs/icons/teama.svg'
    },
    {
        title: 'Complete Transparency',
        img: 'imgs/icons/link.svg'
    },
    {
        title: 'Quality Assured',
        img: 'imgs/icons/tech.svg'
    },
    {
        title: 'On-time delivery',
        img: 'imgs/icons/hi.svg'
    },
    {
        title: '24/7 support',
        img: 'imgs/icons/badge.svg'
    },
    {
        title: 'Effective Communication',
        img: 'imgs/icons/tin.svg'
    },
]


//////////////////////////////// faq //////////////////////////////////

export const faq = [
    {
        cardTitle: 'How much of my input is needed?',
        cardBody: 'Your input is valuable to us. The product we make of your business has a large impact based on your views. We try to take as much input as possible during the first stage of building the product only.'
    },
    {
        cardTitle: "Is the service of maintaining the website after its creation available?",
        cardBody: 'Yes, we can maintain your website for you. Have a look at our @services.'
    },
    {
        cardTitle: "Will my needs be completely assessed if I am on a low budget?",
        cardBody: 'Fulfilling your needs is our priority. We will provide you with the best package available according to your budget that fulfills all your needs.'
    },
    {
        cardTitle: "How much the design of a logo costs? ",
        cardBody: "The price varies on the kind of logo that is needed by the user. Tell us your needs here, and we'll provide you with the best price according to your business needs."
    },
    {
        cardTitle: 'Are the websites mobile-friendly?',
        cardBody: 'Yes, they are. Our team works hard to ensure that every website works well on each device.'
    },
]

///////////////////////////////////  our service 2 ////////////////////////////////////////////

export const ourService2 = [
    {
        cardIcon: "imgs/icons/logo-and-branding.svg",
        cardTitle: 'Ingenious Designs',
        cardContent: 'Creative minds work together to create designs that are distinct yet astonishing. We want to help you grow, and we will'
    },
    {
        cardIcon: 'imgs/icons/service2.svg',
        cardTitle: 'Graphic Designing Services',
        cardContent: 'Designs that represent the entire business, details as significant as every product they sell, and every approach tell a story.'
    },
    {
        cardIcon: 'imgs/icons/service3.svg',
        cardTitle: 'Responsive Web Designing',
        cardContent: "Devices may change,but the website shouldn't. We make sure that whatever device is available to you, your website will run smoothly on it."
    },
    {
        cardIcon: 'imgs/icons/service4.svg',
        cardTitle: 'Static Web Designing',
        cardContent: 'One for all and all for one. Irrespective of who the user is, the data provided on the website is the same for every person.'
    },
    {
        cardIcon: 'imgs/icons/service5.svg',
        cardTitle: 'Dynamic Web Designing',
        cardContent: 'Highly interactive websites for client-server communications, user-friendly and easily manageable as well.'
    },
    {
        cardIcon: 'imgs/icons/service6.svg',
        cardTitle: 'Website Redesign Service',
        cardContent: 'A timely upgradation gives a refresh to the website with graphics,content, navigations which leads to the better performance of the whole site.'
    },
]

///////////////////////// projects 2/////////////////////////

export const projects2=[
    {
        title:'GISR Foundation',
        image:"imgs/work/web4.png"
      },
      {
        title:'IIWA Awards 2021',
        image:'imgs/work/web5.png'
      },
      {
        title:'Tartch LLP',
        image:'imgs/work/web8.png'
      },
]

//////////////////////////// service 7 /////////////////////////////////

export const service7=[
    {
        cardLogo:"imgs/service/logo-design.jpg",
        cardTitle:"Logo Designs",
        cardContent:"A logo is the first step in every business that defines the story behind it. We create what is unique, has a meaning, and leaves you to just look at it."
    },
    {
        cardLogo:"imgs/service/packaging-design.jpg",
        cardTitle:"Packaging Designs",
        cardContent:"Designs that rule, leave marks on the products that you sell."
    },
    {
        cardLogo:"imgs/service/brochure-.jpg",
        cardTitle:"Brochure Designs",
        cardContent:"Designs that explain what you sell and how you sell them in the easiest way possible."
    },
    {
        cardLogo:"imgs/service/visit-card.jpg",
        cardTitle:"Business Card Designs",
        cardContent:"Letting people know where to find you and how the creative and chic designs are designed by complying with the entire business."
    },
    {
        cardLogo:"imgs/service/flyer-.jpg",
        cardTitle:"Flyer Designs",
        cardContent:"Smaller, glossy, and full-colored circulars' designs telling people everything about your business wherever they're going to end up because sometimes it is the traditional marketing that helps you grow."
    },
    {
        cardLogo:"imgs/service/newsletter.jpg",
        cardTitle:"Newsletter Designs",
        cardContent:"News has always been a vital part of our lives and will be. Designing this part of lives in a way that makes it easier to read, good to look at, and leaves you wanting to know more."
    },
]

////////////////////////////// ourService3 //////////////////////////

export const ourService3=[
    {
        cardLogo:"imgs/service/seo.png",
        cardTitle:'Search Engine Optimization',
        cardContent:"Product's right, story's good, and still no good rankings on Google? We've got the solution for you. Leave it up to us to bring traffic to stay on your websites with the right keywords and phrases, which ultimately increases the ranking on different search engines.",
    },
    {
        cardLogo:'imgs/service/ppc.png',
        cardTitle:'Pay per Click',
        cardContent:'An ongoing process that helps you attract traffic to your business with as low investment as possible. Boosting the data about your product to reach various search engines for the potential customers to revert to your website.'
    },
    {
        cardLogo:'imgs/service/smo.png',
        cardTitle:'Social Media Marketing',
        cardContent:"Got a great story for your product but, where to tell? Which place would be better for marketing where you know your customer's already there? The place where you can find the right audience and can interact with them thoroughly is social media. We help you build the audience and reduce friction for the buyers to reach the products."
    },
    {
        cardLogo:'imgs/service/emails.png',
        cardTitle:'Email Marketing',
        cardContent:"We help convert your potential prospects into customers, single-time customers into permanent and loyal shoppers by sending them regular updates of new products, sales information, and other important stuff. We make sure to NOT spam them with a lot of emails of no value."
    },
]